var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"site-header sticky top-0 z-50 bg-white",on:{"mouseleave":function($event){return _vm.setActiveMenu(null)}}},[_c('div',{staticClass:"site-header__inner"},[_c('img',{staticClass:"img-box",attrs:{"src":_vm.logo,"alt":"Liso"},on:{"click":_vm.jumpHome}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }